import React, { useRef, useState, useEffect } from 'react';
import styles from '../arenamajubarretos/arenamajubarretos.module.scss';
const WA = "5516991414590";

const Arenamajubarretos: React.FC = () => {
    const imgRef = useRef<HTMLImageElement>(null);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={styles.arenamajubarretos}>
            <div className={styles["body-thunder"]} style={{ minHeight: `${height}px` }}>
                <div className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <div className={styles.links}>
                        <a
                            href={`https://wa.me/${WA}?text=${encodeURIComponent(
                                "Olá! Vim pelo link da bio e gostaria de mais informações sobre a locação para eventos.",
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkGradient}
                        >
                            <span>Agendamento Eventos</span>
                        </a>
                        <a
                            href={`https://wa.me/${WA}?text=${encodeURIComponent(
                                "Olá! Vim pelo link da bio e gostaria de mais informações sobre as aulas de futevôlei.",
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkGradient}
                        >
                            <span>Agendamento Futevôlei</span>
                        </a>
                        <a
                            href={`https://wa.me/${WA}?text=${encodeURIComponent(
                                "Olá! Vim pelo link da bio e gostaria de mais informações sobre a locação de quadra.",
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkGradient}
                        >
                            <span>Agendamento Quadra</span>
                        </a>
                        <a
                            href="https://maps.app.goo.gl/yTJjx79YxQWd7bXX6"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkGradient}
                        >
                            <span>Localização</span>
                        </a>
                        <a
                            href="https://www.instagram.com/arenamaju.barretos?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.linkGradient}
                        >
                            <span>Instagram</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Arenamajubarretos;
